import { render, staticRenderFns } from "./LabBaseFirebase_.vue?vue&type=template&id=2668c1b3&"
import script from "./LabBaseFirebase_.vue?vue&type=script&lang=js&"
export * from "./LabBaseFirebase_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports